/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MediaUiCirclePauseIcon20Regular = forwardRef('MediaUiCirclePauseIcon20Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M8 6.25a.75.75 0 0 1 .75.75v6a.75.75 0 0 1-1.5 0V7A.75.75 0 0 1 8 6.25Z" }),
        React.createElement("path", { d: "M12.75 7a.75.75 0 0 0-1.5 0v6a.75.75 0 0 0 1.5 0V7Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.001 10A7.999 7.999 0 1 1 18 10 7.999 7.999 0 0 1 2 10Zm8-6.499A6.499 6.499 0 1 0 10 16.5 6.499 6.499 0 0 0 10 3.5Z" })));
});
